import jStat from 'jstat';
import type { TwoArrayParams } from './types';
import type { CovarianceResult } from '../../components/calculators/covariance/covariance-calculator';

/**
 * Calculates covariance between two variables
 * @param params Object containing two arrays of data
 * @returns Object containing covariance and related statistics
 */
export function calculateCovariance({ data1, data2 }: TwoArrayParams): CovarianceResult {
  if (data1.length !== data2.length) {
    throw new Error('Arrays must have the same length');
  }

  const covariance = jStat.covariance(data1, data2);
  const mean1 = jStat.mean(data1);
  const mean2 = jStat.mean(data2);
  const sampleSize = data1.length;

  return {
    covariance,
    sampleSize,
    data1: Array.from(data1),
    data2: Array.from(data2),
    mean1,
    mean2
  };
} 